<template>
    <div class="main-footer">
        <span>© 2023. Dashbyte. All Rights Reserved.</span>
        <span>Created by: <a href="http://themepixels.me/" target="_blank">Themepixels</a></span>
      </div>
</template>